var SENTRY_RELEASE;SENTRY_RELEASE={name: "Pentarchy", version: "0.1.0"};